import OrderSearchPage from './order-search';

export default OrderSearchPage;